import React, { Component } from 'react';
import moment from 'moment';
import { Card } from 'reactstrap';
import { Group } from '@vx/group';
import { BarGroup } from '@vx/shape';
import { AxisBottom, AxisLeft } from '@vx/axis';
import { scaleBand, scaleLinear } from '@vx/scale';
import { ParentSize } from '@vx/responsive';
import { withTooltip, TooltipWithBounds } from '@vx/tooltip';
import { localPoint } from '@vx/event';

export class UpcomingLotsGraph extends Component {
  handleMouseOver = (event, data) => {
    const coords = localPoint(event.target.ownerSVGElement, event);
    this.props.showTooltip({
      tooltipLeft: coords.x,
      tooltipTop: coords.y,
      tooltipData: `Volume: ${data.value}`
    });
  };

  render() {
    const { lots, tooltipData, tooltipLeft, tooltipTop, tooltipOpen, hideTooltip } = this.props;
    const barBlue = '#bceff8';
    const keys = ['volume'];
    const topMargin = 30;
    const days = [];
    for (let i = 0; i < 7; i++) {
      days.push(
        moment()
          .startOf('week')
          .add(i, 'days')
          .format('YYYY-MM-DD')
      );
    }
    let mergedLots = {};
    lots.forEach(l => {
      if (!mergedLots[l.vesselTransferDate]) {
        mergedLots[l.vesselTransferDate] = {
          vesselTransferDate: l.vesselTransferDate,
          volume: l.volume
        };
        return;
      }

      mergedLots[l.vesselTransferDate].volume += l.volume;
    });
    mergedLots = Object.keys(mergedLots).map(k => mergedLots[k]);

    // Accessor the X ais
    const x0 = d => d.vesselTransferDate;

    // Scales
    const x0Scale = scaleBand({
      domain: days,
      padding: 0.2
    });
    const x1Scale = scaleBand({
      domain: ['vesselTransferDate'],
      padding: 0.1
    });

    const yScale = scaleLinear({
      domain: [0, Math.max(...mergedLots.map(d => d.volume)) * 1.5]
    });

    const height = 150;
    const leftMargin = 50;
    return (
      <Card className="pa3 mb4">
        <h3 className="h5 h-auto mb4">Estimated completed volumes for the week:</h3>
        <ParentSize>
          {p => {
            const xMax = p.width;
            const yMax = height - topMargin;

            x0Scale.rangeRound([0, xMax]);
            x1Scale.rangeRound([0, x0Scale.bandwidth()]);
            yScale.range([yMax, 0]);
            return (
              <div className="relative">
                <svg width={p.width} height={height}>
                  <rect x={0} y={0} width={p.width} height={height} fill="#fff" />
                  <Group left={leftMargin}>
                    <BarGroup
                      data={mergedLots}
                      keys={keys}
                      height={yMax}
                      x0={x0}
                      x0Scale={x0Scale}
                      x1Scale={x1Scale}
                      yScale={yScale}
                      color={() => barBlue}
                    >
                      {barGroups => {
                        return barGroups.map(barGroup => {
                          return (
                            <Group key={`bar-group-${barGroup.index}-${barGroup.x0}`} left={barGroup.x0}>
                              {barGroup.bars.map(bar => {
                                return (
                                  <rect
                                    key={`bar-group-bar-${barGroup.index}-${bar.index}-${bar.value}-${bar.key}`}
                                    x={bar.x}
                                    y={bar.y}
                                    width={bar.width}
                                    height={bar.height}
                                    fill={bar.color}
                                    onMouseLeave={hideTooltip}
                                    onMouseMove={event => {
                                      this.handleMouseOver(event, bar);
                                    }}
                                  />
                                );
                              })}
                            </Group>
                          );
                        });
                      }}
                    </BarGroup>
                  </Group>
                  <AxisLeft scale={yScale} top={0} left={leftMargin} label={'Volume (L)'} labelOffset={25} />
                  <AxisBottom
                    top={yMax}
                    left={leftMargin}
                    scale={x0Scale}
                    tickFormat={d => {
                      return moment(d).format('ddd');
                    }}
                    tickLabelProps={() => ({
                      fontSize: 11,
                      textAnchor: 'middle'
                    })}
                  />
                </svg>
                {tooltipOpen && (
                  <TooltipWithBounds
                    // set this to random so it correctly updates with parent bounds
                    key={Math.random()}
                    top={tooltipTop}
                    left={tooltipLeft}
                  >
                    {tooltipData}
                  </TooltipWithBounds>
                )}
              </div>
            );
          }}
        </ParentSize>
      </Card>
    );
  }
}

export default withTooltip(UpcomingLotsGraph);



// WEBPACK FOOTER //
// ./src/components/upcomingLotsGraph/upcomingLotsGraph.jsx